import React from "react";
import {
  CLink,
  CBanner,
  H2,
  Text,
  P,
  Box,
  Flex
} from "@appcues/component-library";
import styled from "styled-components";
import CoolTip from "components/Common/CoolTip";

const UrlRollup = props => {
  const { anonymousMaus, monthlyActiveUsers, overFivePercentUrls } = props;

  const overallAnonymousPercent = Math.round(
    (anonymousMaus / monthlyActiveUsers) * 100,
    2
  );
  const overallIdentifiedPercent = 100 - overallAnonymousPercent;

  const urlDisplays = overFivePercentUrls.map(url => {
    const totalPercent = parseInt(url.total_percent);
    const anonUserPercent = parseInt(url.anon_percent_of_total);
    const identifiedUserPercent = 100 - anonUserPercent;

    return (
      <TopUrlWrapper key={url.url}>
        <Flex width="50%" alignSelf="center">
          <Text is="div" truncate>
            {url.url}
          </Text>
        </Flex>
        <Flex alignItems="center" position="relative" width="35%">
          <PercentText>{`${Math.round(totalPercent)}%`}</PercentText>
          <Box
            complete={totalPercent}
            borderRadius={5}
            height={7}
            overflow="hidden"
            width={`${totalPercent}%`}
            marginRight={8}
          >
            <Box
              width={`${identifiedUserPercent}%`}
              backgroundColor="$gray-5"
              height="100%"
              borderRadius={5}
            />
          </Box>
          <CoolTip
            tip={`${Math.round(
              identifiedUserPercent
            )}% identified | ${Math.round(anonUserPercent)}% anonymous users`}
          />
        </Flex>
      </TopUrlWrapper>
    );
  });

  return (
    <div>
      <P paddingTop={16}>
        MAU count higher than you would expect? The following might help
        determine what is going on.
      </P>
      {overallAnonymousPercent > 0 && (
        <Box marginTop={32}>
          <SectionTitle>User breakdown</SectionTitle>
          <Flex marginY={12} alignItems="baseline" color="$gray-5">
            <H2 type="secondary">{overallIdentifiedPercent}%</H2> &nbsp;
            logged-in users
          </Flex>
          <Flex marginBottom={12} alignItems="baseline" color="$gray-5">
            <H2 type="secondary">{overallAnonymousPercent}%</H2> &nbsp;
            anonymous users
          </Flex>
          <CBanner marginTop={16}>
            <CBanner.Content>
              If you don&#39;t want to show Appcues to anonymous users, you (or
              a developer on your team) can remove the{" "}
              <strong>Appcues.anonymous()</strong> call from your installation.{" "}
              <CLink
                href="https://docs.appcues.com/article/438-anonymous-users"
                isExternal
              >
                Learn more.
              </CLink>
            </CBanner.Content>
          </CBanner>
        </Box>
      )}
      {urlDisplays.length > 0 && (
        <Box marginTop={32}>
          <SectionTitle>Views per page</SectionTitle>
          {urlDisplays}
          <CBanner
            marginTop={16}
            text="These pages account for a large quantity of total page views. If you dont want to count users on these pages, you (or a developer on your team) can remove the Appcues script from them."
          />
        </Box>
      )}
    </div>
  );
};

export default UrlRollup;

const SectionTitle = styled.strong`
  padding-bottom: 8px;
`;

const PercentText = styled.strong`
  flex: 0 0 40px;
  color: ${props => props.theme["$gray-7"]};
`;

const TopUrlWrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme["$gray-3"]};
  display: flex;
  height: 40px;
  justify-content: space-between;
`;
